import React, { useEffect, useRef, useState } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { OverlayTrigger } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  ChevronUp,
  RotateCcw,
  Sliders,
  Calendar,
} from "feather-icons-react/build/IconComponents";
import Select from "react-select";
import { Table } from "antd";
import { Checkbox } from "antd";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { setheadertoggle } from "../../../redux/toggle";
import { useDispatch, useSelector } from "react-redux";
import { getEinvoiceStatusReport } from "../../../services/ReportApiService";
import {
  DatatablePagingParameter,
  Filterclass,
} from "../../../core/json/DatatablePagingParameters";
import { renderTooltip } from "../../../redux/helper";
import {
  exportreportExcel,
  exportreportPDF,
  printreportReport,
} from "../../../core/utils/MainReportUtils";
import LoadingUtils from "../../../core/utils/LoadingUtils";

const statusOptions = [
  { value: "", label: "All" },
  { value: "NOT REPORTED", label: "NOT REPORTED" },
  { value: "REPORTED", label: "REPORTED" },
  { value: "SUBMITTED", label: "SUBMITTED" },
  { value: "FAILED", label: "FAILED" },
];

const ZtcaStatusReport = () => {
  const [searchText, setSearchText] = useState("");
  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState(dayjs());
  const [toDate, setToDate] = useState(dayjs());
  const [statusFilter, setStatusFilter] = useState(null);
  const [totalcount, setTotalcount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  const dispatch = useDispatch();
  const { branch } = useSelector((state) => state.branchlist);
  const { companyInfolist } = useSelector((state) => state.companyInfo);
  const { togglehead } = useSelector((state) => state.headerToggle);
  const tableRef = useRef(null);

  useEffect(() => {
    handleGetReport();
  }, [branch]);

  const handleGetReport = async () => {
    setLoading(true);
    const DatatablePagingParameters = new DatatablePagingParameter();
    DatatablePagingParameters.PageNumber = 1;
    DatatablePagingParameters.PageSize = -1;
    const formattedfromDate = dayjs(fromDate).format("YYYY-MM-DD");
    const formattedtoDate = dayjs(toDate).format("YYYY-MM-DD");
    const Filters = new Filterclass();
    Filters.Branch = branch;
    Filters.FromDate = formattedfromDate;
    Filters.ToDate = formattedtoDate;
    if (statusFilter?.value) {
      Filters.Status = statusFilter.value;
    }
    try {
      const response = await getEinvoiceStatusReport({
        DatatablePagingParameters,
        Filters,
      });
      const data = response?.data?.einvoiceStatusReportDetail || response?.data || [];
      const list = Array.isArray(data) ? data : [];
      setAllData(list);
      setTotalcount(list.length);
    } catch (error) {
      console.error("Error fetching ZTCA Status Report:", error?.response?.data?.Message);
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setFromDate(dayjs());
    setToDate(dayjs());
    setStatusFilter(null);
    setSearchText("");
  };

  const handleFromDateChange = (date) => {
    setFromDate(date);
    setToDate(null);
  };

  const menuItems = [
    { value: "1", label: "Bill Date", checked: true },
    { value: "2", label: "Bill No", checked: true },
    { value: "3", label: "Section", checked: true },
    { value: "4", label: "Response Status", checked: true },
    { value: "5", label: "ReSubmit Status", checked: true },
    { value: "6", label: "Response Message", checked: true },
    { value: "7", label: "Invoice Type", checked: true },
  ];

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const columns = [
    {
      title: "Bill Date",
      key: "1",
      dataIndex: "billDate",
      render: (text) => <span>{formatDate(text)}</span>,
      sorter: (a, b) => new Date(a.billDate) - new Date(b.billDate),
      defaultSortOrder: "ascend",
    },
    {
      title: "Bill No",
      key: "2",
      dataIndex: "billNo",
      sorter: (a, b) => {
        const aNum = parseInt(a.billNo, 10);
        const bNum = parseInt(b.billNo, 10);
        if (!isNaN(aNum) && !isNaN(bNum)) return aNum - bNum;
        return String(a.billNo).localeCompare(String(b.billNo));
      },
    },
    {
      title: "Section",
      key: "3",
      dataIndex: "section",
      render: (text) => <span>{typeof text === "object" ? text?.name : text}</span>,
      sorter: (a, b) => {
        const aName = typeof a.section === "object" ? a.section?.name : a.section;
        const bName = typeof b.section === "object" ? b.section?.name : b.section;
        return String(aName || "").localeCompare(String(bName || ""));
      },
    },
    {
      title: "Response Status",
      key: "4",
      dataIndex: "responseStatus",
      sorter: (a, b) => String(a.responseStatus || "").localeCompare(String(b.responseStatus || "")),
    },
    {
      title: "ReSubmit Status",
      key: "5",
      dataIndex: "reSubmitStatus",
      sorter: (a, b) => String(a.reSubmitStatus || "").localeCompare(String(b.reSubmitStatus || "")),
    },
    {
      title: "Response Message",
      key: "6",
      dataIndex: "responseMsg",
      sorter: (a, b) => String(a.responseMsg || "").localeCompare(String(b.responseMsg || "")),
    },
    {
      title: "Invoice Type",
      key: "7",
      dataIndex: "invoiceType",
      sorter: (a, b) => String(a.invoiceType || "").localeCompare(String(b.invoiceType || "")),
    },
  ];

  const [selectedColumns, setSelectedColumns] = useState();

  useEffect(() => {
    const initialSelectedColumns = menuItems
      .filter((item) => item.checked)
      .map((item) => columns.find((col) => col.key === item.value));
    setSelectedColumns(initialSelectedColumns);
  }, []);

  const handleCheckboxChange = (columnKey, checked) => {
    if (checked) {
      setSelectedColumns((prev) => {
        const updated = [...prev, columns.find((col) => col.key === columnKey)];
        return updated.sort((a, b) => (a.key > b.key ? 1 : -1));
      });
    } else {
      setSelectedColumns((prev) => prev.filter((col) => col.key !== columnKey));
    }
  };

  const modifiedList = allData.filter((obj) => {
    const billNo = String(obj.billNo || "").toLowerCase();
    const section = typeof obj.section === "object" ? obj.section?.name || "" : String(obj.section || "");
    const responseStatus = String(obj.responseStatus || "").toLowerCase();
    const invoiceType = String(obj.invoiceType || "").toLowerCase();
    const search = searchText.toLowerCase();

    const searchMatch =
      billNo.includes(search) ||
      section.toLowerCase().includes(search) ||
      responseStatus.includes(search) ||
      invoiceType.includes(search);

    const statusMatch = !statusFilter?.value || obj.responseStatus === statusFilter.value;

    return searchMatch && statusMatch;
  });

  const getActiveTabData = () => {
    const createfieldMapping = (cols) => {
      const mappings = {};
      cols.forEach((col) => {
        mappings[col.title] = col.dataIndex;
      });
      return mappings;
    };
    const fieldMapping = createfieldMapping(columns);
    return {
      data: modifiedList,
      columns: selectedColumns,
      fieldMapping,
      Rname: "ZTCA Status Report",
    };
  };

  const handletogglehead = () => {
    dispatch(setheadertoggle(!togglehead));
  };

  const handleRefresh = () => {
    handleGetReport();
  };

  return (
    <div>
      <LoadingUtils loading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>ZTCA Status Report</h4>
              </div>
            </div>

            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip("PDF")}>
                  <button
                    onClick={() => exportreportPDF(getActiveTabData, {}, companyInfolist)}
                    disabled={loading}
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip("Excel")}>
                  <button
                    onClick={() => exportreportExcel(getActiveTabData, {}, companyInfolist)}
                    disabled={loading}
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <ImageWithBasePath src="assets/img/icons/excel.svg" alt="excel-icon" />
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip("Print")}>
                  <button
                    onClick={() => printreportReport(getActiveTabData, {}, companyInfolist)}
                    disabled={loading}
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <i data-feather="printer" className="feather-printer" />
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={() => renderTooltip("Refresh")}>
                  <Link onClick={handleRefresh}>
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip("Collapse")}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={togglehead ? "active" : ""}
                    onClick={handletogglehead}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>

          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set mt-2">
                  <div className="search-input">
                    <Link to="#" className="btn btn-searchset">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-search"
                      >
                        <circle cx={11} cy={11} r={8} />
                        <line x1={21} y1={21} x2="16.65" y2="16.65" />
                      </svg>
                    </Link>
                    <div id="DataTables_Table_0_filter" className="dataTables_filter">
                      <label>
                        <input
                          type="search"
                          className="form-control form-control-sm"
                          placeholder="Search"
                          aria-controls="DataTables_Table_0"
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                        />
                      </label>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <div className="input-blocks">
                      <label htmlFor="from-date">From Date</label>
                      <div className="input-groupicon calender-input">
                        <Calendar className="info-img" />
                        <DatePicker
                          className="datetimepicker"
                          id="from-date"
                          placeholderText="From Date"
                          value={fromDate}
                          onChange={handleFromDateChange}
                          startDate={fromDate}
                          selectsStart
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="input-blocks mr-2">
                      <label htmlFor="to-date">To Date</label>
                      <div className="input-groupicon calender-input">
                        <Calendar className="info-img" />
                        <DatePicker
                          id="to-date"
                          placeholderText="To Date"
                          value={toDate}
                          onChange={(date) => setToDate(date)}
                          minDate={fromDate}
                          startDate={fromDate}
                          selectsEnd
                          disabled={!fromDate}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="input-blocks">
                      <label>Status</label>
                      <Select
                        className="img-select"
                        options={statusOptions}
                        value={statusFilter}
                        onChange={setStatusFilter}
                        isClearable
                        classNamePrefix="react-select"
                        placeholder="All Status"
                      />
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-end mt-4">
                  <div className="input-blocks me-2">
                    <Link
                      className="btn btn-filters ms-auto"
                      onClick={() => {
                        setCurrentPage(1);
                        setPageSize(20);
                        handleGetReport();
                      }}
                    >
                      <i data-feather="search" className="feather-search" /> Search
                    </Link>
                  </div>
                  <div className="input-blocks">
                    <button className="btn btn-reset rounded-2" onClick={handleReset}>
                      <i data-feather="refresh-cw" className="feather-refresh-cw" /> Reset
                    </button>
                  </div>
                </div>

                <div className="dropdown">
                  <button
                    className="btn dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <Sliders className="info-img" />
                  </button>
                  <ul className="dropdown-menu p-2">
                    {menuItems.map((obj, i) => (
                      <li key={i}>
                        <Checkbox
                          onChange={(e) => handleCheckboxChange(obj.value, e.target.checked)}
                          defaultChecked={obj.checked}
                        >
                          <div style={{ color: "black" }}>{obj.label}</div>
                        </Checkbox>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {selectedColumns && (
                <div className="table-responsive product-list">
                  <Table
                    columns={selectedColumns}
                    dataSource={modifiedList}
                    ref={tableRef}
                    id="table-to-export"
                    className="table datanew dataTable no-footer custom-table"
                    rowKey={(record, index) => index}
                    pagination={{
                      showTotal: (total, range) =>
                        `${range[0]}-${range[1]} of ${modifiedList?.length} items`,
                      current: currentPage,
                      pageSize: pageSize,
                      total: modifiedList?.length,
                      onChange: (page, size) => {
                        setCurrentPage(page);
                        setPageSize(size);
                      },
                      showSizeChanger: true,
                      pageSizeOptions: ["10", "20", "50", "100"],
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ZtcaStatusReport;
